import PropTypes from 'prop-types';
import { useMemo } from 'react';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import buildTourFilterOptions from '../../../../../helpers/buildTourFilterOptions';
import useTourFilter from '../../../../../hooks/useTourFilter';

const TourDifficultyFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { searchObj, filters, applyFilter } = useTourFilter(tripId);

  const options = useMemo(
    () => buildTourFilterOptions(filters?.difficulties, searchObj.difficulties),
    [filters, searchObj.difficulties],
  );

  if (options.length === 0) {
    return <></>;
  }

  return (
    <CheckboxSelectFilter
      label="Difficulty"
      options={options}
      values={searchObj.difficulties || []}
      onChange={(difficulties) => applyFilter({ difficulties })}
      variant={variant}
      filterSpacingClass={filterSpacingClass}
      filterMaxWidthClass="max-w-full"
      menuWidthClass="w-full md:w-max"
    />
  );
};

TourDifficultyFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

TourDifficultyFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};

export default TourDifficultyFilter;
